var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimulationdaily(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 184 184",
    fillRule: "evenodd",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 2.03,2.09 C 2.03,2.09 2.06,181.94 2.06,181.94 2.06,181.94 182.03,181.97 182.03,181.97 182.03,181.97 182.06,1.97 182.06,1.97 182.06,1.97 2.03,2.09 2.03,2.09 Z M 52.97,44.00 C 52.97,44.00 53.06,116.94 53.06,116.94 53.06,116.94 115.09,117.00 115.09,117.00 115.09,117.00 102.03,127.03 102.03,127.03 102.03,127.03 97.12,145.91 97.12,145.91 97.12,145.91 115.09,145.91 115.09,145.91 115.09,145.91 131.06,116.97 131.06,116.97 131.06,116.97 130.97,43.97 130.97,43.97 130.97,43.97 52.97,44.00 52.97,44.00 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimulationdaily);
export default __webpack_public_path__ + "static/media/simulationdaily.609ac68cc268083db33a1e7d87c36a33.svg";
export { ForwardRef as ReactComponent };